import { TeamTab } from '../components/TeamTab';

export function MembersSection() {
  return <TeamTab />;
}
